import FocusTrap from 'focus-trap-react';
import { observer } from 'mobx-react';
import * as React from 'react';
import { OpenableState } from '../../../../../Modal/UseOpenable';

export interface Props {
  content: React.JSX.Element;
  modalState: OpenableState;
}

const Content: React.FC<Props> = ({ content, modalState }) => {
  switch (modalState.kind) {
    case 'open':
      return (
        <FocusTrap
          active={true}
          focusTrapOptions={{
            escapeDeactivates: false,
            allowOutsideClick: true,
            fallbackFocus: '#popover-container',
          }}
        >
          {content}
        </FocusTrap>
      );
    case 'closed':
      return <></>;
  }
};

export default observer(Content);
